module.exports = __webpack_public_path__ + "img/dsci0122.7f025726.jpg";